import {Button, Modal, TextInput} from "@mantine/core";
import {useContext} from "react";
import {useForm, UseFormInput} from "@mantine/form";
import CreateFolderPayload from "../../../../api/folder/CreateFolderPayload";
import FolderContext from "../../../../contexts/folder/FolderContext";
import Folder from "../../../../api/folder/Folder";
import Notifications from "../../../../utils/notifications/Notifications";
import CreateFolderDialogContext from "./CreateFolderDialogContext";

/**
 * Form
 * @author Kacper Faber
 * @since 0.1.9
*/
const formInput: UseFormInput<CreateFolderPayload> = {
    initialValues: {
        name: ''
    },

    validate: {
        name: (e: string) => e.length > 3 ? null : 'Przynajmniej trzy znaki'
    }
};

/**
 * Creates new folder using FolderContext.
 * Use CreateFolderDialogContext to work with it.
 * @since 0.1.9
 * @author Kacper Faber
 */
function CreateFolderDialog() {
    const {isOpened, setOpened} = useContext(CreateFolderDialogContext);

    /**
     * Folder context
     * @author Kacper Faber
     * @since 0.1.9
    */
    const folderContext = useContext(FolderContext);

    // noinspection SpellCheckingInspection
    /**
     * Form hook from @mantine/forms
     * @author Kacper Faber
     * @since 0.1.9
    */
    const form = useForm(formInput);

    /**
     * On API responded with OK - Folder is created.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onCreateSuccess = (_: Folder) => {
        setOpened(false);
    }

    /**
     * On form is submitted and data are valid.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onSubmit = (data: CreateFolderPayload) => {
        folderContext.create(data)
            .then(onCreateSuccess)
            .catch(Notifications.onFetchError);
    };

    /**
     * When modal is going to be closed.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onClose = () => {
        setOpened(false);
    }

    return (
        <Modal opened={isOpened} onClose={onClose}>
            <form onSubmit={form.onSubmit(onSubmit)}>
                <TextInput
                    placeholder='Nazwa'
                    variant='filled'
                    key={form.key('name')}
                    { ...form.getInputProps('name') }
                />

                <Button
                    fullWidth
                    mt="xl"
                    type="submit"
                    children="Zapisz"
                />
            </form>
        </Modal>
    );
}

export default CreateFolderDialog;

// TODO: CreateFolderDialog.tsx
//  Looks terrible
//  Deleting does not work